/**
 * Vytvoření workeru pro idle timeout izolované v samostatném souboru.
 * `import.meta` nelze zkompilovat v Jestu (module: commonjs), proto se tento soubor
 * v testech nahrazuje stubem přes `moduleNameMapper` v jest.preset.js.
 */
export function createIdleTimeoutWorker(): Worker {
  return new Worker(new URL('./idle-timeout.worker', import.meta.url));
}
